import { createAdapter } from './adapter';
export * from './services';
export * from './model';
export * from './types';
export * from './utils';

export { createAdapter };
export default { createAdapter };
